import { render, staticRenderFns } from "./FreightTableRouteCargos.vue?vue&type=template&id=5b938e18&scoped=true"
import script from "./FreightTableRouteCargos.vue?vue&type=script&lang=js"
export * from "./FreightTableRouteCargos.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRouteCargos.vue?vue&type=style&index=0&id=5b938e18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b938e18",
  null
  
)

export default component.exports